import React from 'react';
import styles from './styles/styles.module.scss';
import { ProfilePhotoShimmer, ContentBlock, TextShimmer, ShimmerWrapper } from '../ShimmerBase/ShimmerBase';

const FeedItemShimmer = () => {
  return (
    <ShimmerWrapper className={styles.container}>
      <div className={styles.profileAndText}>
        <ProfilePhotoShimmer />
        <div className={styles.metadata}>
          <TextShimmer className={styles.topText} />
          <TextShimmer className={styles.bottomText} />
        </div>
      </div>
      <ContentBlock />
    </ShimmerWrapper>
  );
};

export default FeedItemShimmer;
